export const ClearIcon = () => {
  return (
    <svg fill="none" height="16" viewBox="0 0 16 16" width="16" xmlns="http://www.w3.org/2000/svg">
      <path d="M4.47803 7.39453H11.5223V8.60547H4.47803V7.39453Z" fill="#8A858E" />
      <circle cx="8" cy="8" r="7.5" stroke="#8A858E" />
    </svg>
  );
};
